/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PtwErrorId = {
    None: 'None',
    ErrorDdc1Config: 'Error_DDC1_Config',
    ErrorDdc2Config: 'Error_DDC2_Config',
    ErrorDdc3Config: 'Error_DDC3_Config',
    ErrorTempA: 'Error_TempA',
    ErrorTempB: 'Error_TempB',
    ErrorTempC: 'Error_TempC',
    ErrorTempD: 'Error_TempD',
    ErrorPressure: 'Error_Pressure',
    ErrorFifoCorr: 'Error_FIFO_corr',
    ErrorFifoUncorr: 'Error_FIFO_uncorr',
    ErrorFifoUnderrun: 'Error_FIFO_Underrun',
    ErrorFifoOverrun: 'Error_FIFO_Overrun',
    ErrorHv: 'Error_HV',
    ErrorHvUndervoltage: 'Error_HV_Undervoltage',
    ErrorHvOvervoltage: 'Error_HV_Overvoltage',
    ErrorOverload: 'Error_Overload',
    ErrorIntegratorCorr: 'Error_Integrator_corr',
    ErrorIntegratorUncorr: 'Error_Integrator_uncorr',
    ErrorFabric: 'Error_Fabric',
    ErrorFabricConfig: 'Error_Fabric_Config',
    ErrorFirmwareCrc: 'Error_Firmware_Crc',
    ErrorDeviceIntegrity: 'Error_Device_Integrity',
    ErrorIdentityService: 'Error_Identity_Service',
    ErrorUnicheckApp: 'Error_Unicheck_App',
    ErrorServerConnection: 'Error_Server_Connection',
    ErrorMainboardConfig: 'Error_Mainboard_Config',
    ErrorHvCalibrationConfig: 'Error_HV_Calibration_Config',
    ErrorRadiologicConfig: 'Error_Radiologic_Config',
    ErrorBatteryStatus: 'Error_Battery_Status',
    ErrorIotBoardConfig: 'Error_IotBoard_Config',
    ErrorInterfaceBoardConfig: 'Error_InterfaceBoard_Config',
    ErrorHostnameConfig: 'Error_Hostname_Config',
    ErrorSettingConfig: 'Error_Setting_Config',
    ErrorIotIdentityConfig: 'Error_IotIdentity_Config',
    ErrorIotIdentityCache: 'Error_IotIdentityCache',
    ErrorHvReturnCalibrationConfig: 'Error_HvReturnCalibration_Config',
    ErrorConnectionUsb: 'Error_ConnectionUsb',
    ErrorNotCalibrated: 'Error_NotCalibrated',
    ErrorVersionsFirmware: 'Error_VersionsFirmware',
    ErrorDeviceState: 'Error_DeviceState',
    ErrorDeviceGeneral: 'Error_DeviceGeneral',
    ErrorAnalysisGeneral: 'Error_Analysis_General',
    ErrorCrc: 'Error_CRC',
    ErrorZeroSignalTooHigh: 'Error_ZeroSignalTooHigh',
    ErrorBeamOnDuringOffsetMeasurement: 'Error_BeamOnDuringOffsetMeasurement',
    ErrorAnalysisTemperatureDeviation: 'Error_Analysis_TemperatureDeviation',
    ErrorAnalysisTemperatureOutOfLimit: 'Error_Analysis_TemperatureOutOfLimit',
    ErrorAnalysisAirPressureOutOfLimit: 'Error_Analysis_AirPressureOutOfLimit',
    ErrorAnalysisCalibrationCorrupted: 'Error_Analysis_CalibrationCorrupted',
    ErrorAnalysisMathError: 'Error_Analysis_MathError',
    ErrorAnalysisInvalidSetupParameter: 'Error_Analysis_InvalidSetupParameter',
    ErrorAnalysisSkipped: 'Error_Analysis_Skipped',
    ErrorIoTDeviceUnavailable: 'Error_IoTDevice_Unavailable',
    ErrorIoTDeviceInUse: 'Error_IoTDevice_InUse',
    ErrorMeasurementStartServiceNotReady: 'Error_MeasurementStart_ServiceNotReady',
    ErrorMeasurementRunningNoBeamOnDetected: 'Error_MeasurementRunning_NoBeamOnDetected',
    ErrorMeasurementRunningNoBeamOffDetected: 'Error_MeasurementRunning_NoBeamOffDetected',
    ErrorMeasurementRunningStreamingError: 'Error_MeasurementRunning_StreamingError',
    ErrorCommunicationMeasurementService: 'Error_Communication_MeasurementService',
    ErrorIoTDeviceDefectDetected: 'Error_IoTDevice_DefectDetected'
} as const;
export type PtwErrorId = typeof PtwErrorId[keyof typeof PtwErrorId];


export function PtwErrorIdFromJSON(json: any): PtwErrorId {
    return PtwErrorIdFromJSONTyped(json, false);
}

export function PtwErrorIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): PtwErrorId {
    return json as PtwErrorId;
}

export function PtwErrorIdToJSON(value?: PtwErrorId | null): any {
    return value as any;
}

/**
 * Check if a given object implements the PtwErrorId interface.
 */
 export function instanceOfPtwErrorId(value: any): value is PtwErrorId {
    return Object.values(PtwErrorId).includes(value)
}

